import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    width: '100%',
    margin: 'auto',
    minWidth: '1200px',
  },
  formLabel: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '20px',
    color: '#666666',
  },
  formLabelHighlighted: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 12,
    lineHeight: '20px',
    color: '#df0c36',
    marginTop: 10,
  },
  inputBoxHighlighted: {
    '& > div div div input': {
      fontFamily: 'Helvetica Neue LT Std',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 12,
      color: '#df0c36',
      marginTop: 0,
    },
    '& > div div input': {
      fontFamily: 'Helvetica Neue LT Std',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 12,
      color: '#df0c36',
      marginTop: 0,
    },
    '& > div input': {
      fontFamily: 'Helvetica Neue LT Std',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 12,
      color: '#df0c36',
      marginTop: 0,
    },
    '& > div': {
      fontFamily: 'Helvetica Neue LT Std',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 12,
      color: '#df0c36',
      marginTop: 0,
    },
  },
  select: {
    height: 40,
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '27px',
    color: '#403e3e',
  },
  label: {
    marginTop: 10,
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '20px',
    color: '#403e3e',
    textTransform: 'capitalize',
  },
  amountLabel: {
    marginTop: 10,
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '20px',
    color: '#403e3e',
    margin: 12,
    textTransform: 'capitalize',
  },
  datePicker: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    color: '#403e3e',
    lineHeight: '20px',
    width: 130,
    height: 40,
    marginTop: 0,
    paddingRight: 0,
  },
  invoicePaper: {
    margin: '22px 0px',
    width: '100%',
    minHeight: 100,
    maxHeight: 360,
    overflowY: 'auto',
    minWidth: '1180px',
  },
  removeButton: {
    color: '#DF0C36',
    padding: '3px 0px',
    cursor: 'pointer',
    margin: '5px 10px',
  },
  removeAllButton: {
    color: '#DF0C36',
    padding: '3px 0px',
    cursor: 'pointer',
    margin: '0px 10px',
  },
  middleGrid: {
    flexBasis: '6%',
  },
  matchButton: {
    zIndex: 1,
    position: 'absolute',
    top: '70%',
    left: '51%',
    height: 40,
    width: 40,
    color: '#FFFFFF',
    backgroundColor: '#DF0C36',
    '&:hover': {
      backgroundColor: '#DF0C36',
    },
  },
  editMatchButton: {
    zIndex: 1,
    position: 'absolute',
    top: '70%',
    left: '54%',
    height: 40,
    width: 40,
    color: '#FFFFFF',
    backgroundColor: '#DF0C36',
    '&:hover': {
      backgroundColor: '#DF0C36',
    },
  },
  addButton: {
    bottom: 0,
    left: 15,
    position: 'absolute',
    height: 36,
    width: 36,
    color: '#DF0C36',
    '&:hover': {
      color: '#DF0C36',
    },
  },
  activityInput: {
    width: 130,
  },
  activityInputHighlight: {
    width: 138,
  },
  row: {
    height: 42,
    margin: '10px 0px',
  },
  container: {
    padding: '12px 0px',
  },
  autocompleteInput: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '11px',
    lineHeight: '20px',
    color: '#666666',
    height: 18,
  },
  autocomplete: {
    marginRight: '30px',
  },
  option: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '18px',
    color: '#666666',
  },
  checkbox: {
    color: '#666666 !important',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
    padding: '0px 0px',
  },
  checkboxSelected: {
    color: '#DF0C36 !important',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
    padding: '0px 0px',
  },
  addButtomItem: {
    minHeight: '120px',
    position: 'relative',
  },
  loader: {
    color: '#DF0C36',
    position: 'fixed',
    left: '50%',
    top: '50%',
  },
  helperText: {
    marginLeft: 0,
    marginRight: 0,
    fontSize: '10px',
  },
  historicButton: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 12,
    lineHeight: '20px',
    color: '#DF0C36',
    padding: '0px 10px 0px 0px',
    wordBreak: 'break-all',
    '&:hover': {
      textDecorationLine: 'underline',
      backgroundColor: '#ffffff',
    },
  },
  grid: {
    padding: '4px 0px !important',
  },
  input: {
    paddingRight: 0,
    width: 100,
  },
  inputStyle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '20px',
    color: '#666666',
    height: 19,
  },
  activityType: { width: 165 },
  currencyInput: {
    width: 150,
    margin: '0 12px',
  },
  gridMinWidth: {
    minWidth: 1450,
  },
  margin12: {
    margin: '10px 12px 12px',
  },
}));
